import styled from 'styled-components'
import { darkGrayColor } from 'uiComponents/constants/colors'
import { fwBold } from 'uiComponents/constants/typography'

const FilterLabel = styled.div`
  padding-top: 27px;
  color: ${darkGrayColor};
  ${fwBold};
`
export default FilterLabel
